interface IViewBudgetButtonProps {
  onClick: () => void;
}

const ViewBudgetButton = (props: IViewBudgetButtonProps) => {
  return (
    <button
      className="text-gray-800 underline underline-offset-2 flex items-center gap-1 hover:opacity-80 text-size-14 whitespace-nowrap"
      onClick={props.onClick}
    >
      <img
        src="/assets/images/docs.svg"
        alt="Documento"
        className="w-6 h-6 flex-shrink-0"
      />
      <span>Visualizar orçamento</span>
    </button>
  );
};

export default ViewBudgetButton;

